
<span v-if="hasImage" class="avatar mr-1" v-bind:style="{'background-image': url}" data-avatar-type="image"></span>
<span v-else class="avatar" data-avatar-type="initials">{{user | initials}}</span>
